export default "__VITE_PUBLIC_ASSET__1949f4f6__"